<template>
    <div class="notice-detail">
      <div class="card">
        <div class="title" v-if='!data.describe'>{{data.title}}</div>

        <!-- 单条汇总 -->
        <div class="group">
          
          <div class="cell" v-if='!data.describe'>
            <label>检测时间：</label>
            <span>{{ data.time || '暂无检测时间' }}</span>
          </div>
          <div class="cell" v-if='!data.describe'>
            <label>检测结果：</label>
            <span>{{ data.content || '暂无检测结果' }}</span>
          </div>
          <div class="cell" v-if='!data.describe'>
            <label>可疑指数：</label>
            <span>{{ data.alarmScore || '暂无检测结果' }}</span>
          </div>

          <div class="cell" style="display: flex" v-if='data.type == 2 && !data.describe'>
            <label style="display: inline-block">结果说明：</label>
            <div style="display: inline-block; flex: 1">
                {{data.content }}：</br>
                <div style='text-indent: 2em'>{{data.description ||'暂无检测报告'}}</div>
                建议：
                <div style='text-indent: 2em'>{{data.suggest ||'暂无建议'}}</div>
            </div>
          </div>
        </div>


        <!-- 多条汇总  -->
        <div class="group" v-if='data.describe'>
            <div class="cell" style="display: flex">
                <span style="display: inline-block; flex: 1">
                    {{data.describe}}
                </span>
            </div>
            <div class="cell" style="display: flex" v-if='data.type == 1'>
              <span style="display: inline-block; flex: 1">
                  {{data.content}}共{{data.allCount}}人次
              </span>
            </div>
            <div class="cell" style="display: flex" v-if='data.type == 2'>
              <span style="display: inline-block; flex: 1" >
                共{{data.allCount}}人次，{{data.content}}
              </span>
            </div>
        </div>
      </div>


      <!-- 动态监测列表 -->
      <div class="card" v-for="item in data.mentalNoticeDeptList" :key="item.id" v-if="data.mentalNoticeDeptList && data.mentalNoticeDeptList.length > 0 && data.type == 1">
        <div class="classname">{{ item.name }}</div>

        <!-- 单条汇总 -->
        <div class="group">
          
          <div class="cell_header_title" style='display:flex'>
            <span style='flex:1;text-align:center'>姓名</span>
            <span style='flex:2;text-align:center'>检测时间</span>
            <span style='flex:1;text-align:center'>可疑指数</span>
             
          </div>
          <div class="cell"  style='display:flex' v-for="(item1,index) in item.mentalNoticeUserDTOS" :key="index">
            
            <span style='flex:1;text-align:center'>{{item1.title}}</span>
            <span style='flex:2;text-align:center'>{{getTime(item1.time)}}</span>
            <span style='flex:1;text-align:center'>{{item1.faceScore }}</span>
          </div>
         
          
        </div>
        
      </div>

      <!-- 静态检测列表  -->
      <div class="card" v-for="item in data.mentalNoticeDeptList" :key="item.id"  v-if="data.mentalNoticeDeptList && data.mentalNoticeDeptList.length > 0 && data.type == 2">
        <div class="classname">{{ item.name }}</div>

        <!-- 单条汇总 -->
        <div class="group">
          
          <div class="cell_header_title" style='display:flex'>
            <span style='flex:1;text-align:center'>姓名</span>
            <span style='flex:2;text-align:center'>检测时间</span>
            <span style='flex:1;text-align:center'>检测结果</span>
             
          </div>
          <div class="cell"  style='display:flex' v-for="(item1,index) in item.mentalNoticeUserDTOS" :key="index">
            
            <span style='flex:1;text-align:center'>{{item1.title}}</span>
            <span style='flex:2;text-align:center'>{{getTime(item1.time)}}</span>
            <span style='flex:1;text-align:center'>{{item1.testResult}}</span>
          </div>
         
          
        </div>
        
      </div>


      <van-popup v-model="resultShow">
        <div class='toast'>
            {{resultContent}}
        </div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import moment, { now } from 'moment';
  import Player from 'xgplayer';
  import 'xgplayer/dist/index.min.css';
  import { ImagePreview } from 'vant';
  import store from '../../store';
  export default {
    name: 'notice-detail',
    data() {
      return {
        signAvatar: '',
        list: [],
        data: {},
  
        // 切换展示报警图片和报警视频
        changeImgOrVideo: 1,
  
        qiling: require('@/assets/qiling.webp'),
        fire: require('@/assets/fire_alarm.webp'),
        // 是否显示回放视频
        isShowBackVideo: false,
        // 测试
        index: 0,
        path: '',

        // 结果说明show
        resultShow:false,
        // 结果说明内容
        resultContent: '',


        timer: '',
        // 当前时间3分钟后的时间
        nowAfter: moment()
          .add(3, 'm')
          .format('YYYY-MM-DD HH:mm:ss')
      };
    },
    created() {
      this.getNoticeDetail();
    },
    mounted() {
  
 
    },
    methods: {
        // 点击展示结果说明
        handleClickShowResult () {
            this.resultShow = true
            this.resultContent = '您当前可能处于一种无力状态下，你感到身体虚弱，精神不振，仿佛失去了往日的活 力和动力。你对日常活动和任务感到力不从心，即使是简单的任务也会让你觉得疲惫不堪 。这种状态可能会影响你的工作和生活质量，让你难以集中精力去完成事情。 建议： 首先，要确保获得充足的休息和优质的睡眠，以帮助恢复体力。同时，尝试进行轻度 的身体活动，如散步或瑜伽，以逐渐增加体力和耐力。在饮食上，选择营养丰富的食物， 为身体提供必要的能量。此外，寻求支持和鼓励也是很重要的，与亲朋好友分享你的感受 ，或者寻求专业的帮助，以找到无力的原因并寻求相应的解决方案。'
        },
      // 点击查看报警视频或报警图片
      handleClickChangeImgOrVideo() {
        if (this.changeImgOrVideo == 1) {
          this.changeImgOrVideo = 2;
          setTimeout(() => {
            this.initPlayer();
          });
        } else {
          this.changeImgOrVideo = 1;
        }
      },
      getTime (date) {
        console.log('date',moment().format('YYYY'))
        if (moment().format('YYYY') == moment(date).format('YYYY')) {
            return moment(date).format('MM-DD HH:mm:ss')
        } else {
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        }
       
      },
  
      // 初始化回放视频插件
      initPlayer() {
        let _this = this;
        console.log('_this.data', _this.data);
        let player = new Player({
          id: 'mse1',
          url: _this.data.playbackUrl,
          poster: _this.data.signAvatar,
          videoInit: true, // 显示首帧
          width: '100%',
          height: '100%',
          cors: true, // 跨域
          autoplay: true,
          playsinline: true
        });
      },
      // 预览图片
      previewImg(imgurl) {
        ImagePreview({
          images: [imgurl]
        });
      },
  
      // 时间格式化
      getTime(time) {
        return moment(time).format('YYYY-MM-DD HH:mm:ss');
      },
      // 获取报警详情
      getNoticeDetail() {
        this.axios
          .get(`student-consumer/api/microNoticeLog/getMicroNoticeLogInfo`, {
            params: {
              id: this.$route.query.id
            }
          })
          .then(res => {
            if (res.code === 200) {
              if (res.data) {
                this.data = res.data;
                // this.data.signAvatar = ''
                this.data.time = (res.data.time && moment(res.data.time).format('YYYY-MM-DD HH:mm:ss')) || '--';
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
  </script>
  
  <style lang="scss" scope>
  .notice-detail {
    // position: relative;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    padding-top: 1rem;
  
    .card {
      background-color: red;
  
      .title {
        padding: 0.8rem 1rem;
        font-size: 0.8rem;
        color: #969799;
  
        border-bottom: 1px solid rgba(244, 244, 246, 0.99);
      }

      .classname {
        padding: 0.8rem 1rem;
        font-size: 0.8rem;
        color: #fff;
        border-radius: 0.75rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        text-align: center;
        background-color: #70B1FF;
        border-bottom: 1px solid rgba(244, 244, 246, 0.99);
      }
  
      margin: 0 1rem 1rem;
      background: #fff;
      /* height: 10rem; */
      box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  
      border-radius: 0.75rem;
  
      .avatar {
        padding: 0;
  
        .name {
          text-align: center;
          font-size: 0.75rem;
          margin-top: 0.7rem;
          color: #969799;
        }
  
        .video {
          width: 21rem;
          height: 12rem;
          margin: 1rem auto;
          border-radius: 1rem;
  
          #mse1 {
            border-radius: 1rem;
          }
        }
      }
  
      img {
        width: 21rem;
        height: 12rem;
        border-radius: 1rem;
        margin: 1rem auto;
        display: block;
        object-fit: cover;
      }
  
      .group {
        font-size: 0.85rem;
  
        .cell {
          padding: 0.8rem 0;
          border-bottom: 1px solid rgba(244, 244, 246, 0.99);
          margin: 0 1rem;
          display: flex;
          align-items: center;
  
          &:last-child {
            border-bottom: none;
          }
  
          label {
            width: 3.9rem;
            // background-color: red;
            color: #969799;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.75rem;
          }
  
          .span_zhenshi {
            background-color: #f46c6c;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
  
          .span_wubao {
            background-color: #8f939c;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
  
          .span_xunjian {
            background-color: #e6a23f;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
        }
        .cell_header_title {
          padding: 0.4rem 1rem;
          background-color: #DBEAFF;
          border-bottom: 1px solid rgba(244, 244, 246, 0.99);
          // margin: 0 1rem;
          display: flex;
          align-items: center;
  
          &:last-child {
            border-bottom: none;
          }
  
          label {
            width: 3.9rem;
            // background-color: red;
            color: #969799;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.75rem;
          }
  
          .span_zhenshi {
            background-color: #f46c6c;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
  
          .span_wubao {
            background-color: #8f939c;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
  
          .span_xunjian {
            background-color: #e6a23f;
            color: #fff;
            border-radius: 0.3125rem;
            padding: 0.1875rem 0.625rem;
          }
        }

      }
    }
  
    .submit {
      // padding-top:10rpx;
      // padding-bottom:10rpx;
      display: block;
      width: 15rem;
      padding: 0.5rem 0;
      margin: 0 auto;
      background: #37a5da;
      font-size: 1rem;
      border-radius: 1rem;
      text-align: center;
      color: #fff;
    }

    // 弹窗内样式
    .toast {
        position: absolute;
        width:80%;
        height:80%;
    }


  }
  
  .success {
    width: 100%;
    height: 2rem;
  }
  </style>
  